/**
 * 適配器工廠
 * 根據當前 Office 上下文自動選擇合適的適配器
 */

import { OutlookAdapter } from './outlookAdapter';
import { CalendarAdapter } from './calendarAdapter';

let cachedAdapter = null;

/**
 * 獲取適合當前環境的適配器
 * @returns {BaseAdapter} 適配器實例
 */
export const getAdapter = () => {
  // 如果已經有緩存的適配器且仍然支援，直接返回
  if (cachedAdapter && cachedAdapter.isSupported()) {
    return cachedAdapter;
  }

  // 先判斷目前 item 是否為 Appointment（活動/會議）
  // 注意：OutlookAdapter 在 Appointment 也可能回傳 supported（因為 mailbox.item 存在）
  // 所以必須優先選 CalendarAdapter
  try {
    const itemType = Office?.context?.mailbox?.item?.itemType;
    const appointmentType = Office?.MailboxEnums?.ItemType?.Appointment;
    if (itemType && appointmentType && itemType === appointmentType) {
      const calendarAdapter = new CalendarAdapter();
      if (calendarAdapter.isSupported()) {
        cachedAdapter = calendarAdapter;
        return cachedAdapter;
      }
    }
  } catch (e) {
    // ignore and fall back to normal detection
  }

  // 檢查並創建 Outlook 適配器
  const outlookAdapter = new OutlookAdapter();
  if (outlookAdapter.isSupported()) {
    cachedAdapter = outlookAdapter;
    return cachedAdapter;
  }

  // 檢查並創建 Calendar 適配器
  const calendarAdapter = new CalendarAdapter();
  if (calendarAdapter.isSupported()) {
    cachedAdapter = calendarAdapter;
    return cachedAdapter;
  }

  // 如果都不支援，返回 Outlook 適配器作為預設（即使不支援也會拋出錯誤）
  cachedAdapter = outlookAdapter;
  return cachedAdapter;
};

/**
 * 清除緩存的適配器（用於測試或環境變更時）
 */
export const clearAdapterCache = () => {
  cachedAdapter = null;
};

